import React from 'react';
import { Helmet } from 'react-helmet-async';

// Composant pour les meta tags SEO de chaque page
export const PageSEO = ({ title, description, image, url }) => {
  const siteName = "Nailed by Chloé";
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Prothésiste Ongulaire à Domicile - La Réunion`;
  const defaultDescription = "Prothésiste ongulaire à domicile à La Réunion. Extensions, semi-permanent et nail art. Service chez vous à Ravine des Cabris, Saint-Pierre, Le Tampon. Prendre RDV sur WhatsApp.";
  const defaultImage = "https://customer-assets.emergentagent.com/job_nailed-by-chloe/artifacts/dmo9kird_Capture%20d%E2%80%99%C3%A9cran%202025-12-30%20201100%20vect.png";
  const siteUrl = "https://nail-technician.preview.emergentagent.com";

  return (
    <Helmet>
      {/* Titre */}
      <title>{fullTitle}</title>
      
      {/* Meta tags de base */}
      <meta name="description" content={description || defaultDescription} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url || siteUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url || siteUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="fr_FR" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url || siteUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={image || defaultImage} />
      
      {/* Autres meta tags */}
      <meta name="author" content="Nailed by Chloé" />
      <meta name="geo.region" content="RE" />
      <meta name="geo.placename" content="La Réunion" />
    </Helmet>
  );
};

// Composant Schema JSON-LD pour LocalBusiness
export const LocalBusinessSchema = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Nailed by Chloé",
    "image": "https://customer-assets.emergentagent.com/job_nailed-by-chloe/artifacts/dmo9kird_Capture%20d%E2%80%99%C3%A9cran%202025-12-30%20201100%20vect.png",
    "description": "Prothésiste ongulaire à domicile à La Réunion - Extensions, semi-permanent, nail art",
    "@id": "https://nail-technician.preview.emergentagent.com",
    "url": "https://nail-technician.preview.emergentagent.com",
    "telephone": "+33640486009",
    "email": "Nailedbychloe@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Ravine des Cabris",
      "addressLocality": "Saint-Pierre",
      "postalCode": "97410",
      "addressRegion": "La Réunion",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": -21.3167,
      "longitude": 55.4833
    },
    "priceRange": "25€ - 70€",
    "currenciesAccepted": "EUR",
    "paymentAccepted": "Cash, Credit Card, PayPal",
    "areaServed": [
      { "@type": "City", "name": "Ravine des Cabris" },
      { "@type": "City", "name": "Saint-Pierre" },
      { "@type": "City", "name": "Le Tampon" },
      { "@type": "City", "name": "Saint-Louis" },
      { "@type": "City", "name": "Saint-Leu" },
      { "@type": "City", "name": "Les Avirons" },
      { "@type": "City", "name": "Étang-Salé" },
      { "@type": "City", "name": "Petite-Île" },
      { "@type": "City", "name": "Saint-Joseph" }
    ],
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      "opens": "08:00",
      "closes": "18:00"
    },
    "sameAs": [
      "https://www.instagram.com/nail.edbychloe/",
      "https://www.facebook.com/profile.php?id=61584927464807"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services de prothésie ongulaire",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Vernis Semi-Permanent Mains",
            "description": "Pose de vernis longue tenue avec finition brillante ou mate"
          },
          "price": "30",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Gainage Ongle Naturel",
            "description": "Renforcement de vos ongles naturels avec gel"
          },
          "price": "40",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Extension Gel-X",
            "description": "Extension souple et naturelle avec capsules gel soft"
          },
          "price": "40",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Extension Capsules",
            "description": "Pose complète avec capsules et gel de construction"
          },
          "price": "50",
          "priceCurrency": "EUR"
        }
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};
